export const BETSLIP_DO_BET_CONSTANTS = {
  ukBetSource: '136132'
};
